export default __webpack_public_path__ + "static/media/Belt of the Sepulcher.5a88af3c.jpg";